<template>
  <div class="loading-screen">
    <div class="planet">
      <SvgImage
        icon="planet-icon"
        width="150"
        height="150"
        class="svg-planet"
      />
      <div class="orbit">
        <SvgImage
          icon="moon-icon"
          width="50"
          height="50"
          class="svg-moon"
        />
      </div>
    </div>
    <div class="rocket">
      <SvgImage
        icon="rocket-icon"
        width="200"
        height="200"
        class="svg-rocket"
      />
    </div>

    <p class="loading-text">
      Aguarde um momento, estamos processando seu pedido...
    </p>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'SpaceLoadingScreen',
  components: {
    SvgImage,
  },
});
</script>

<style lang="scss" scoped>
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: white;
  overflow: hidden;
  position: relative;
}

.svg-planet {
  width: 100px;
  height: 100px;
  animation: rotate 3s linear infinite;
}

.orbit {
  position: absolute;
  top: 45%;
  left: 45%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  @media(max-width: 768px) {
    top: 40%;
    left: 48%;
  }
  @media(max-width: 375px) {
    top: 38%;
    left: 45%;
  }
}

.svg-moon {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translate(-50%, 0);
  animation: orbit 4s linear infinite;
}

.svg-rocket {
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 20%;
  animation: rocket-move 3s ease-in-out infinite;
}

.loading-text {
  margin-top: 20px;
  font-size: 1.8rem;
  text-align: center;
  color: #112C78;
  font-weight: bold;
}

@keyframes rotate {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes orbit {
  0% {
    transform: rotate(0deg) translateX(75px) rotate(0deg);
    z-index: 1;
  }
  25% {
    transform: rotate(90deg) translateX(75px) rotate(-90deg);
    z-index: 1;
  }
  50% {
    transform: rotate(180deg) translateX(75px) rotate(-180deg);
    z-index: 0;
  }
  75% {
    transform: rotate(270deg) translateX(75px) rotate(-270deg);
    z-index: 1;
  }
  100% {
    transform: rotate(360deg) translateX(75px) rotate(-360deg);
    z-index: 1;
  }
}

@keyframes rocket-move {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
</style>
